/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Public_Cta_TextInputs */



/**
* | output |
* | --- |
* | "This document was created with oneAI" |
*
* @param {Artifact_Public_Cta_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_public_cta_text = /** @type {((inputs?: Artifact_Public_Cta_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Public_Cta_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Dokument wurde mit oneAI erstellt")
	return /** @type {LocalizedString} */ ("This document was created with oneAI")
});